import { isReactVersionAtLeast } from "./reactVersion.js";
function inertValue(value) {
  if (isReactVersionAtLeast(19)) {
    return value;
  }
  return value ? "true" : void 0;
}
export {
  inertValue
};
//# sourceMappingURL=inertValue.js.map
